export function setDateFormat(originalDate:string){
    if (!originalDate) {
        return;
    }
    var dateComponents = originalDate.split('/');
    const day = dateComponents[0];
    const month = dateComponents[1];
    const year = dateComponents[2].slice(-2);
    const formattedDate = `${day}/${month}/${year}`;
    
    return formattedDate;
 }